import React from 'react'
import { Image } from '@chatterbug/aaron'

import { TYPES } from 'src/pages/Achievements/subcomponents/AchievementWidget/AchievementWidget'
import AspectRatioImage from 'src/ui/AspectRatioImage/AspectRatioImage'

import LiveLessonImage from '../LiveLessonImage/LiveLessonImage'

const WidgetImage = ({
  showPlaceholder,
  lessonThumbnail,
  widgetType,
  liveLessonReplayUrl,
  isList,
}) => {
  const getImage = (type) => {
    return (
      {
        concept: require('./assets/concepts.svg'),
        flashcards: require('./assets/flashcards.svg'),
        media: require('./assets/media.svg'),
        writing: require('./assets/writing.svg'),
      }[type] || './assets/media.svg'
    )
  }
  if (widgetType === TYPES.LIVE_LESSON) {
    return (
      <LiveLessonImage
        showPlaceholder={showPlaceholder}
        liveLessonReplayUrl={liveLessonReplayUrl}
        lessonThumbnail={lessonThumbnail}
        isList={isList}
      />
    )
  }

  return (
    <>
      {showPlaceholder ? (
        <Image src={getImage(widgetType)} />
      ) : (
        <AspectRatioImage
          imgUrl={lessonThumbnail}
          aspectRatio="16:9"
          borderRadius="0,5x"
        />
      )}
    </>
  )
}

export default WidgetImage
